
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import Link from './../../zviz2/zviz/components/link';
import TextInput from './../../zviz2/zviz/components/form/text';
import PanelBlueprint from './../elements/panel';
import {extend, cloneObject, trimLowerCase} from './../../zviz2/zviz/functions';
import {styleWords, styleText} from './../../styles';
//import {LifeCycle} from './../zviz2/zviz/cycle';

class SearchController extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.searchTerm = state.get('filter.search');
        if(! this.searchTerm){
            this.searchTerm = '';
        }

    }

    doSearch(){
        let searchQuery = trimLowerCase(document.getElementById('searchInput').value);
        if(searchQuery == ''){
            searchQuery = null;
        }
        state.set('filter.search', searchQuery);
    }

    setSearch(name, value, oldvalue){
        this.searchTerm = value;
        document.getElementById('searchInput').value = value || '';
        this.update();
    }


}

let BlueprintChild = {
    type: SearchController,
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.setSearch], 'filter.search') ),
    ],
    properties: {
        style: { 
            maxHeight: '110px'
         },
        // content: 'Search content'
        data: {search: (ctrl) => (state.get('filter.search'))}
    },
    events: {  },
    children: [ 
        
        extend({
            properties: {
                content: 'Search by country, theme, year, project symbol, evaluation manager or by a general word search.',
                style: extend({
                    marginBottom: '10px',
                    fontSize: '10pt'
                }, styleText)
            }
        }, TextBox),

        extend({
            properties: {
                style: extend({
                    border: '1px solid #151F85',
                    padding: '0% 17% 0% 2%',
                    fontStyle: 'italic',
                    height: '30px',
                    lineHeight: '30px',
                    outline: 'none',
                    width: '80%'
                }, styleText),
                attributes: { 
                    'id': 'searchInput',
                    'placeholder': 'Search keyword',
                    'value': (ctrl) => ( state.get('filter.search') || '' /*ctrl.parent.searchTerm || ''*/ )
                }
            },
            events: {
                keyup: (event, ctrl) => {
                    if(event.which == 13 || event.keyCode == 13) {
                        ctrl.parent.doSearch();
                    }
                }
            }
        }, TextInput),

        extend({
            properties: {
                style: extend({
                    display: 'block',
                    width: '18%',
                    position: 'relative',
                    top: '-29px',
                    left: '80%',
                    backgroundColor: '#151F85',
                    color: 'white',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    height: '26px',
                    lineHeight: '26px',
                    fontSize: '9pt'
                }, styleWords),
                content: 'Find'
            },
            events: {
                click: (event, ctrl) => { ctrl.parent.doSearch() }
            }
        }, Link)
    ]
}

let Blueprint = extend({
    properties: {
        data: {title: 'Search'},
    },
    private: {
        children: [ cloneObject(BlueprintChild) ]
    }
}, PanelBlueprint);

export default Blueprint;
export {SearchController as Controller, Blueprint};
